import { JSX } from "react";
import { WarningFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import Text from "../../components/Text/Text";
import color from "../../resource/color";

// e.g. "1 ธ.ค. 2569" — the th locale is only imported in App.tsx, not set globally.
function formatThaiShortDate(value?: string | null): string {
  if (!value) return "-";
  const d = dayjs(value);
  return d.isValid() ? d.locale("th").format("D MMM BBBB") : "-";
}

interface Props {
  startDate?: string | null;
  endDate?: string | null;
}

// Shown above the review-condition fields while the year-end closing review is open,
// when those fields are locked.
function ClosingReviewNotice({ startDate, endDate }: Props): JSX.Element {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        background: color.lightWarning,
        borderRadius: 8,
        padding: "12px 16px",
        marginBottom: 20,
      }}
    >
      <WarningFilled style={{ color: color.warning, fontSize: 16, marginTop: 3 }} />
      <div>
        <Text fontWeight={700} fontSize={14} color="Text2">
          แก้ไม่ได้ระหว่างรอบพิจารณาระดับสิ้นปี {formatThaiShortDate(startDate)} - {formatThaiShortDate(endDate)}
        </Text>
        <div style={{ marginTop: 2 }}>
          <Text fontSize={13} color="Text2">
            เกณฑ์นี้กำหนดคิวพิจารณาระดับของรอบนี้ แก้ได้อีกครั้งหลังปิดรอบพิจารณา
          </Text>
        </div>
      </div>
    </div>
  );
}

export default ClosingReviewNotice;
